// assets/search.js

document.addEventListener('DOMContentLoaded', () => {
  const searchForm = document.querySelector('.header__search form');
  const searchInput = document.querySelector('.header__search input');
  const searchButton = document.querySelector('.header__search button');

  if (searchForm && searchInput && searchButton) {
    // Focus input when clicking on search container
    searchForm.addEventListener('click', () => {
      searchInput.focus();
    });

    // Prevent empty searches
    searchForm.addEventListener('submit', (event) => {
      if (searchInput.value.trim() === '') {
        event.preventDefault();
        searchInput.focus();
      }
    });

    // Add predictive search functionality here if using Shopify's API
  }
});